import { render, staticRenderFns } from "./account.vue?vue&type=template&id=27774344&scoped=true&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"
import style0 from "./account.vue?vue&type=style&index=0&id=27774344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27774344",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27774344')) {
      api.createRecord('27774344', component.options)
    } else {
      api.reload('27774344', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=27774344&scoped=true&", function () {
      api.rerender('27774344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/account.vue"
export default component.exports